module.exports = __webpack_public_path__ + "img/4th-grade-en.d6afd733.png";